export enum ImgPosition {
  TOP = 'top',
  RIGHT = 'right',
  LEFT = 'left',
}
